import { IOrganizationProductListItem } from './../../../../services/organization.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LogService } from 'src/app/services/log.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { AppFieldValidators } from 'src/app/utilities/validators';

@Component({
  selector: 'app-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFormComponent {
  public readonly minValue = 0.000000001;
  public readonly maxValue = 2000000000;

  @Input()
  productForm: any;
  formGroup: UntypedFormGroup = this._fb.group({});
  Validators = AppFieldValidators;

  @Input() orgId: number;

  get isSubmitDisabled() : boolean {
    return !this.formGroup.dirty || this.formGroup.invalid
  };


  get formTitle() {
    return this.isProductUpdate()
      ? 'OrganizationDetails.Products.UpdateProduct'
      : 'OrganizationDetails.Products.AddProduct';
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProductFormVM,
    private _mdr: MatDialogRef<ProductFormComponent>,
    private _fb: UntypedFormBuilder,
    private _logger: LogService,
    private _os: OrganizationService,
  ) {
    this.initializeForm(data);
  }

  onCancelClick() {
    this._mdr.close();
  }

  onSubmit() {
    this.saveAndCloseForm();
  }

  private initializeForm(data: ProductFormVM) {
    this._logger.log('ProductFormComponent:initializeForm', data);
    this.orgId = data.orgId;
    this.productForm = this.data.product;
  }

  private isProductUpdate() {
    return this.productForm?.productId > 0;
  }

  private saveAndCloseForm() {
    if (this.formGroup.invalid) return false;
    this._os.saveProduct(this.orgId, this.formGroup.value).subscribe({
      next: (product) => {
        this._logger.log('ProductFormComponent:saveForm:response', product);
        this._mdr.close(product);
      },
    });
  }
}

export interface ProductFormVM {
  orgId: number;
  product: IOrganizationProductListItem;
};
